import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { View, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import DashboardStackNavigator from './DashboardStackNavigator';
import ExploreStackNavigator from './ExploreStackNavigator';
import InsightsStackNavigator from './InsightsStackNavigator';
import ProfileStackNavigator from './ProfileStackNavigator';
import SavedScreen from '../screens/Saved/SavedScreen';
import { Theme } from '../components/ui';
import Ionicons from '@expo/vector-icons/Ionicons';

export type MainTabParamList = {
  Home: undefined;
  Explore: undefined;
  Insights: undefined; // Steps stack navigator (route name kept for compatibility)
  Saved: undefined;
  Profile: undefined;
};

const Tab = createBottomTabNavigator<MainTabParamList>();

const MainTabNavigator = () => {
  const insets = useSafeAreaInsets();
  
  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        tabBarIcon: ({ focused, color, size }) => {
          let iconName;
          let iconSize = 22; // Default size
          
          if (route.name === 'Home') {
            iconName = focused ? 'home' : 'home-outline';
          } else if (route.name === 'Explore') {
            iconName = focused ? 'compass' : 'compass-outline';
          } else if (route.name === 'Insights') {
            iconName = focused ? 'sparkles' : 'sparkles-outline';
          } else if (route.name === 'Saved') {
            iconName = focused ? 'heart' : 'heart-outline';
          } else if (route.name === 'Profile') {
            iconName = focused ? 'person' : 'person-outline';
          }
          
          return <Ionicons name={iconName as any} size={iconSize} color={color} />;
        },
        tabBarActiveTintColor: Theme.colors.textPrimary,
        tabBarInactiveTintColor: '#565b63',
        tabBarStyle: {
          backgroundColor: Theme.colors.surface,
          borderTopWidth: 0.3,
          borderTopColor: 'rgba(35, 38, 45, 0.4)',
          paddingTop: 8,
          paddingBottom: insets.bottom || 8,
          height: 70 + (insets.bottom || 0),
        },
        tabBarLabelStyle: {
          fontSize: 10,
          fontFamily: Theme.typography.fontFamily.medium,
          marginTop: 4,
        },
        headerShown: false,
      })}
    >
      <Tab.Screen 
        name="Home" 
        component={DashboardStackNavigator} 
        options={{ title: 'Home' }} 
      />
      <Tab.Screen 
        name="Explore" 
        component={ExploreStackNavigator} 
        options={{ title: 'Explore' }} 
      />
      <Tab.Screen 
        name="Insights" 
        component={InsightsStackNavigator} 
        options={{ title: 'Steps' }} 
      />
      <Tab.Screen 
        name="Saved" 
        component={SavedScreen} 
        options={{ title: 'Saved' }} 
      />
      <Tab.Screen 
        name="Profile" 
        component={ProfileStackNavigator} 
        options={{ title: 'Your Profile' }} 
      />
      </Tab.Navigator>
  );
};

export default MainTabNavigator; 